/* eslint-disable no-nested-ternary */
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { MobileMenu } from "../../components/MobileMenu";
import actionBarConfig from "../ActionBarContainer/actionBarConfig.json";
import serviceContent from "./content/content.json";

interface Props {
  show: boolean;
  serviceCatalogueNav?: boolean;
  myProfile?: boolean;
  onClose: () => void;
}

export const MobileMenuContainer: React.FC<Props> = ({ serviceCatalogueNav, myProfile, ...props }) => {
  const { path } = useRouteMatch();

  const items = serviceCatalogueNav && !myProfile ? serviceContent.mobileNavBarConfig : serviceContent.myProfileConfig;
  return (
    <>
      <MobileMenu
        {...props}
        currentPath={path}
        menu={items}
        serviceCatalogueNav
        showActionBar={!actionBarConfig.hiddenPathList.includes(path)}
        myProfile={myProfile}
      />
    </>
  );
};

MobileMenuContainer.defaultProps = {
  myProfile: false,
};
